import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from './snackbar.component';
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { StringUtilsHelper } from '../../helpers/strings.helper';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  openSnackBarError(arg0: string) {
    throw new Error('Method not implemented.');
  }
	constructor(private snackBar: MatSnackBar) {}

  public openSnackBarInfo(message: string,) {
    this.snackBar.openFromComponent(SnackbarComponent, {
			horizontalPosition: 'right',
      verticalPosition: 'top' ,
      duration: 3*1000,
      data: { message: message, },
      panelClass: ['info-snackbar']
    });
  }

  public openSnackBarCheck(message: string, time?: number) {
    if(!StringUtilsHelper.notNullOrUndefinedOrEmpty(time)){
      time = 3*1000;
    }
    this.snackBar.openFromComponent(SnackbarComponent, {
			horizontalPosition: 'right',
      verticalPosition: 'top' ,
      duration: time,
      data: { message: message, },
      panelClass: ['check-snackbar']
    });
  }

  public openSnackBarCaution(message: string,) {
    this.snackBar.openFromComponent(SnackbarComponent, {
			horizontalPosition: 'right',
      verticalPosition: 'top' ,
      duration: 3*1000,
      data: { message: message, },
      panelClass: ['caution-snackbar']
    });
  }

  public openSnackBarWarning(message: string,) {
    this.snackBar.openFromComponent(SnackbarComponent, {
			horizontalPosition: 'right',
      verticalPosition: 'top' ,
      duration: 3*1000,
      data: { message: message, },
      panelClass: ['warning-snackbar']
    });
  }

  public openSnackBarDanger(message: string,) {
    this.snackBar.openFromComponent(SnackbarComponent, {
			horizontalPosition: 'right',
      verticalPosition: 'top' ,
      duration: 3*1000,
      data: { message: message, },
      panelClass: ['danger-snackbar']
    });
  }


  public openSnackBarCheckCustom(message: string, imageUrl: string = '', imageAlt: string = '') {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      horizontalPosition: 'right',
      verticalPosition: 'top' ,
      data: { message, imageUrl, imageAlt },
      duration: 1500,
      panelClass: ['success-snackbar']
    });
  }

  public openSnackBarDangerCustom(message: string) {
    this.snackBar.open(message, 'Cerrar', {
      duration: 1500,
      panelClass: ['danger-snackbar']
    });
  }
}
